import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule], // Importa CommonModule para usar *ngIf
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent {
  @Input() title: string = 'Error'; // Título del modal
  @Input() message: string = 'Ha ocurrido un error.'; // Mensaje del modal
  @Input() showErrorModal: boolean = false; // Controla la visibilidad del modal
  @Output() close = new EventEmitter<void>(); // Evento para cerrar el modal

  onClose(): void {
    this.close.emit(); // Emite el evento de cierre
  }
}
